exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-uploads-transition .card[data-v-10413fdf]{transition:transform .15s}.file-limit-reached[data-v-10413fdf]{padding:0 5px;color:#ccc}.upload-button[data-v-10413fdf]{margin-top:10px}", ""]);

// exports
